







import React from "react";
import ReactDOM from "react-dom";
// import './index.css'; // Import Tailwind CSS

import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import App from "./App2";
// import App from "./App2 draft v13";
// import App from "./App3";
import * as serviceWorker from './serviceWorker';
// import MapComponent from "./MapComponent";
// console.log(MapComponent);
// import { Provider } from 'react-redux';
// import { ConfigureStore } from './redux/configureStore';



const Home = () => {
  return (
    <div>
      <h2>Welcome to the Map Application!</h2>
      <p>
        This application allows you to find and save locations on a map. You can
        add markers, upload images and videos, and add notes.
      </p>
      <p>Navigate to the "Add Marker" page to start adding your locations!</p>
    </div>
  );
};


// Create the store using the ConfigureStore function
// const store = ConfigureStore();

// Disable pull-to-refresh globally via JS to avoid CSS conflicts
document.body.style.overscrollBehaviorY = "none";
if (document.documentElement) {
  document.documentElement.style.overscrollBehaviorY = "none";
}

const rootElement = document.getElementById("root");
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then(function (registration) {
    console.log('P2P ServiceWorker registration successful with scope: ', registration.scope);
  }).catch(function (err) {
    console.log('P2P ServiceWorker registration failed: ', err);
  });
}
// serviceWorker.register();
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {/* <Router> */}
    {/* <Provider store={store}> */}
    <App />
    {/* </Provider> */}
    {/* </Router> */}
  </React.StrictMode>
);
